"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForUpdate = exports.valueMeetsCriteria = exports.SharedValueStoreContext = exports.useSharedValueStoreContext = void 0;
const shared_values_model_1 = require("../shared-values.model");
const react_1 = require("react");
const shared_collection_context_1 = require("./shared-collection-context");
const events_context_1 = require("./events-context");
const shared_value_function_context_1 = require("./shared-value-function-context");
const shared_store_reader_1 = require("../shared-store-reader");
/* eslint-disable @typescript-eslint/camelcase */
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
const immer_1 = require("immer");
const react_dom_1 = require("react-dom");
const operators_1 = require("../../operators");
function useSharedValueStoreContext() {
    const store = react_1.useContext(shared_values_model_1.SharedValueContext);
    return react_1.useMemo(() => new SharedValueStoreContext(store), [store]);
}
exports.useSharedValueStoreContext = useSharedValueStoreContext;
class SharedValueStoreContext {
    constructor(store) {
        this.store = store;
        this.collection = new shared_collection_context_1.SharedCollectionContext(store);
        this.funcs = new shared_value_function_context_1.SharedValueFunctionContext(this);
        this.events = new events_context_1.SharedStoreEventsContext(this);
    }
    batch(action) {
        react_dom_1.unstable_batchedUpdates(action);
    }
    get(key, valueKeyOrKeys) {
        if (isValueFunction(key)) {
            return this.funcs.get(key);
        }
        else if (isCollectionKey(key)) {
            return this.collection.get(key, valueKeyOrKeys);
        }
        else
            return shared_store_reader_1.getSharedValue(this.store, key);
    }
    /*eslint-enable no-dupe-class-members*/
    getAll(key) {
        return this.collection.getAll(key);
    }
    waitFor(key, valueKeyOrCriteria, criteria) {
        if (isValueFunction(key)) {
            return this.funcs.waitFor(key, valueKeyOrCriteria);
        }
        else if (isCollectionKey(key)) {
            const valueKey = valueKeyOrCriteria;
            return this.collection.waitFor(key, valueKey, criteria);
        }
        else {
            return this.waitForValue(key, valueKeyOrCriteria);
        }
    }
    waitForNext(event, filter) {
        return this.events.waitForNext(event, filter);
    }
    on(event, listener) {
        return this.events.on(event, listener);
    }
    stream(event) {
        return this.events.stream(event);
    }
    dispatch(event, payload) {
        return this.events.dispatch(event, payload);
    }
    changes(key, valueKeyOrKeys) {
        if (isValueFunction(key)) {
            return this.funcs.changes(key);
        }
        else if (isCollectionKey(key)) {
            return this.collection.changes(key, valueKeyOrKeys);
        }
        else
            return this.store.onChange(key.id);
    }
    /*eslint-enable no-dupe-class-members*/
    anyChanges(key) {
        if (key)
            return this.collection.anyChanges(key);
        else
            return this.store.onAnyChange();
    }
    set(key, valueKeyOrValue, value) {
        if (isCollectionKey(key)) {
            const valueKey = valueKeyOrValue;
            return this.collection.set(key, valueKey, value);
        }
        else {
            this.store.setValue(key.id, valueKeyOrValue);
        }
    }
    modify(key, valueKeyOrModify, modify) {
        if (isCollectionKey(key)) {
            this.collection.modify(key, valueKeyOrModify, modify);
        }
        else {
            const current = this.get(key);
            const newValue = immer_1.produce(current, valueKeyOrModify);
            this.set(key, newValue);
        }
    }
    /*eslint-enable no-dupe-class-members*/
    modifyAll(key, modify) {
        this.collection.modifyAll(key, modify);
    }
    update(key, update) {
        return this.collection.update(key, update);
    }
    delete(key, valueKey) {
        this.collection.delete(key, valueKey);
    }
    clear(key) {
        this.collection.clear(key);
    }
    service(factory) {
        const service = factory(this);
        return lodash_mapvalues_1.default(service, wrapServiceFunction);
    }
    waitForValue(key, criteria) {
        const value = shared_store_reader_1.getSharedValue(this.store, key);
        if (valueMeetsCriteria(value, criteria))
            return Promise.resolve(value);
        else
            return waitForUpdate(this.store, key.id, criteria);
    }
}
exports.SharedValueStoreContext = SharedValueStoreContext;
function valueMeetsCriteria(value, criteria) {
    if (!criteria)
        return !!value;
    else
        return criteria(value);
}
exports.valueMeetsCriteria = valueMeetsCriteria;
function waitForUpdate(store, key, criteria) {
    return store
        .onChange(key)
        .pipe(operators_1.waitForNext(criteria))
        .toPromise();
}
exports.waitForUpdate = waitForUpdate;
function isCollectionKey(key) {
    return key['collection'] === true;
}
function isValueFunction(key) {
    return typeof key === 'function';
}
function wrapServiceFunction(serviceFunc) {
    return (...args) => {
        let returnValue;
        react_dom_1.unstable_batchedUpdates(() => {
            returnValue = serviceFunc(...args);
        });
        return returnValue;
    };
}
//# sourceMappingURL=shared-values-context.js.map